module.exports = __webpack_public_path__ + "static/media/plus-icon.2d16fe04.svg";